import { Component, ElementRef, HostBinding, ViewChild } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styles: [],
    standalone: false,
})
export class AppComponent {
}
